module.exports = __webpack_public_path__ + "assets/img/3_1296_big.9e6c0bcb.jpg";